import irisBannerShopZoneActionTypes from '../actionTypes/IrisBannerShopZoneActionTypes';

function IrisBannerShopZoneReducer(state = [], action) {
    switch (action.type) {
        default:
            return state;

        case irisBannerShopZoneActionTypes.IRIS_BANNER_SHOPZONE_SUCCESS:
            return action.bannerShopZoneInfo;

        case irisBannerShopZoneActionTypes.IRIS_BANNER_SHOPZONE_ERROR:
            return {
                isFailedToFetchIrisInfo: true,
            };
    }
}

IrisBannerShopZoneReducer.reducerName = 'irisBannerShopZoneReducer';
export default IrisBannerShopZoneReducer;
